/* eslint-disable */
/**
 * Created by Administrator on 2018/3/17.
 */
//常用方法
var GCommon = ({
    //字符串是否空
    IsNullOrEmpty: function (str) {
        var str2 = str;
        try {
            str2 = str.toString();
        }
        catch (e) {
        }
        if (str2 == undefined || str2 == null || str2 == "" || str2 == "null") {
            return true;
        } else {
            return false;
        }
    },
    //日期格式
    FormatDateStr: function (date_in, formatStr) {
        var str = formatStr;
        if (str == undefined || str == null || str == "") {
            str = "YYYY-MM-DD HH:mm:ss";
        }
        if (date_in == null || date_in == undefined || date_in == "") {
            return "";
        }
        if (date_in != null && date_in != undefined && date_in.time != null && date_in.time != undefined) {
            date_in = date_in.time;
        } else {
            date_in = date_in.toString();
            // /Date(1455984000000)/
            if (date_in.indexOf("Date") > 0) {
                date_in = date_in.toString().replace("/Date(", "").replace(")/", "");
            }
        }
        var date = new Date(parseInt(date_in));
        var Week = ['日', '一', '二', '三', '四', '五', '六'];
        str = str.replace(/yyyy|YYYY/, date.getFullYear());
        str = str.replace(/yy|YY/, (date.getYear() % 100) > 9 ? (date.getYear() % 100).toString() : '0' + (date.getYear() % 100));
        var month = parseInt(date.getMonth()) + 1;
        str = str.replace(/MM/, month > 9 ? month.toString() : '0' + month);
        str = str.replace(/M/g, month);
        str = str.replace(/w|W/g, Week[date.getDay()]);
        str = str.replace(/dd|DD/, date.getDate() > 9 ? date.getDate().toString() : '0' + date.getDate());
        str = str.replace(/d|D/g, date.getDate());
        str = str.replace(/hh|HH/, date.getHours() > 9 ? date.getHours().toString() : '0' + date.getHours());
        str = str.replace(/h|H/g, date.getHours());
        str = str.replace(/mm/, date.getMinutes() > 9 ? date.getMinutes().toString() : '0' + date.getMinutes());
        str = str.replace(/m/g, date.getMinutes());
        str = str.replace(/ss|SS/, date.getSeconds() > 9 ? date.getSeconds().toString() : '0' + date.getSeconds());
        str = str.replace(/s|S/g, date.getSeconds());
        return str;
    },
    //获取Url参数
    GetUrlParm: function (name) {
        var sURL = window.location.search;
        var re = new RegExp("[?|&]" + name + "=([^&?]+)", "ig");
        var result = re.exec(sURL);
        if (result) {
            var temp = result[0].split('=');
            return temp[1];
        } else {
            return "";
        }
    },

    //获取顶层窗口
    GetTopWin: function () {
        return window.top.window;
    },
    // //获取顶层窗口的大小
    // GetTopWinWidth: function () {
    //     var width = $(top.window.document).width();
    //     return width;
    // },
    // //获取最大窗口大小
    // GetBigDialogWidth: function (to_width) {
    //     var width = $(top.window.document).width() - 100;
    //     if (to_width != null && to_width != undefined && to_width < width) {
    //         width = to_width;
    //     }
    //     return width;
    // },
    // //获取最大窗口高度
    // GetBigDialogHeight: function () {
    //     var height = $(top.window.document).height() - 22;
    //     return height;
    // },

    //获取浏览器版本
    GetBrowserInfo: function () {
        var agent = navigator.userAgent.toLowerCase();
        var regStr_ie = /msie [\d.]+/gi;
        var regStr_ff = /firefox\/[\d.]+/gi
        var regStr_chrome = /chrome\/[\d.]+/gi;
        var regStr_saf = /safari\/[\d.]+/gi;
        if (agent.indexOf("msie") > 0) {//IE
            return agent.match(regStr_ie);
        }
        if (agent.indexOf("firefox") > 0) {//firefox
            return agent.match(regStr_ff);
        }
        if (agent.indexOf("chrome") > 0) {//Chrome
            return agent.match(regStr_chrome);
        }
        if (agent.indexOf("safari") > 0 && agent.indexOf("chrome") < 0) {//Safari
            return agent.match(regStr_saf);
        }
        return "unknow";
    },
    //判断浏览器是否支持
    IsBrowserOK: function () {
        var version = GCommon.GetBrowserInfo().toString();
        if (version.indexOf("msie") >= 0) {
            if (version.indexOf("9.") > 0 || version.indexOf("8.") > 0 || version.indexOf("7.") > 0 || version.indexOf("6.") > 0) {
                return false;
            }
        }
        return true;
    },

    //判断是否手机号
    CheckPhone: function (phoneNum) {
        var flag = false;
        var msg = "格式不正确";
        var check = /^1[3|4|5|8][0-9]{9}$/;
        if (phoneNum == null || phoneNum == undefined || phoneNum == "") {
            flag = false;
            msg = "请输入手机号";
        } else if (phoneNum.length != 11) {
            flag = false;
            msg = "应为11位长度";
        } else if (!check.test(phoneNum)) {
            flag = false;
            msg = "格式不正确";
        } else {
            flag = true;
            msg = "格式正确";
        }
        return { flag: flag, msg: msg };
    },
    //判断是否符合登录名的要求
    CheckLoginName: function (loginName) {
        let flag = false;
        let msg = "格式不正确";
        let check = /^[a-zA-Z0-9]{5,16}$/;
        if (loginName == null || loginName == undefined || loginName == "") {
            flag = false;
            msg = "请输入登录名";
        } else if (loginName.length < 5 || loginName.length > 16) {
            flag = false;
            msg = "长度应为5到16位";
        } else if (!check.test(loginName)) {
            flag = false;
            msg = "只能由数字和字母组成";
        } else {
            flag = true;
            msg = "格式正确";
        }
        return { flag: flag, msg: msg };
    },
    //判断是否符合密码规范
    CheckPwd: function (pwd) {
        let flag = false;
        let msg = "格式不正确";
        let check = /^[a-zA-Z0-9]{5,16}$/;
        if (pwd == null || pwd == undefined || pwd == "") {
            flag = false;
            msg = "请输入密码";
        } else if (pwd.length < 5 || pwd.length > 16) {
            flag = false;
            msg = "长度应为5到16位";
        } else {
            flag = true;
            msg = "格式正确";
        }
        return { flag: flag, msg: msg };
    }
});

export default GCommon;



// WEBPACK FOOTER //
// ./src/GCommon.js